export const PASSWORD_POLICY_MIN_LENGTH = 8
/**
 * 5 minutes
 */
export const QUERY_CACHE_TIME = 1000 * 60 * 5 // 5 minutes
/**
 * 4 hours in seconds - default AUTH_TOKEN_EXP value
 */
export const DEFAULT_AUTH_TOKEN_EXP = 60 * 60 * 4 // 4 hours in seconds
/**
 * Session stale time in milliseconds - matches AUTH_TOKEN_EXP default
 * Use for queries that should not auto-refetch during a session but allow manual refetch
 */
export const QUERY_SESSION_STALE_TIME = DEFAULT_AUTH_TOKEN_EXP * 1000

export const MINIMUM_OWNERSHIP_FOR_UBO = 25
